import React from "react";

export const TriangleInfo = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_6022_2638)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#FFF5CC" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_6022_2638)"
      />
      <path
        d="M23.1665 24.8335V19.8335C23.1665 19.3752 23.5415 19.0002 23.9998 19.0002C24.4582 19.0002 24.8332 19.3752 24.8332 19.8335V24.8335C24.8332 25.2918 24.4582 25.6668 23.9998 25.6668C23.5415 25.6668 23.1665 25.2918 23.1665 24.8335ZM23.9998 26.5002C23.3082 26.5002 22.7498 27.0585 22.7498 27.7502C22.7498 28.4418 23.3082 29.0002 23.9998 29.0002C24.6915 29.0002 25.2498 28.4418 25.2498 27.7502C25.2498 27.0585 24.6915 26.5002 23.9998 26.5002ZM33.6498 30.5668C33.0665 31.6918 31.8415 32.3335 30.3082 32.3335H17.6998C16.1582 32.3335 14.9415 31.6918 14.3582 30.5668C13.7665 29.4335 13.9332 27.9835 14.7748 26.7668L21.4748 16.1668C22.0665 15.3168 22.9998 14.8335 23.9998 14.8335C24.9998 14.8335 25.9332 15.3168 26.4998 16.1418L33.2332 26.7835C34.0748 28.0002 34.2332 29.4418 33.6415 30.5668H33.6498ZM31.8582 27.7168C31.8582 27.7168 31.8415 27.7002 31.8415 27.6835L25.1165 17.0585C24.8748 16.7168 24.4582 16.5002 23.9998 16.5002C23.5415 16.5002 23.1248 16.7168 22.8665 17.0918L16.1582 27.6835C15.6415 28.4168 15.5248 29.2168 15.8248 29.7918C16.1165 30.3585 16.7832 30.6668 17.6915 30.6668H30.2915C31.1998 30.6668 31.8665 30.3585 32.1582 29.7918C32.4582 29.2168 32.3415 28.4168 31.8498 27.7168H31.8582Z"
        fill="#F39C12"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_6022_2638"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_6022_2638"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.861176 0 0 0 0 0.305882 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6022_2638"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6022_2638"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6022_2638"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E5A031" stop-opacity="0.81" />
        <stop offset="1" stop-color="#FFE5A7" stop-opacity="0.42" />
      </linearGradient>
    </defs>
  </svg>
);
